/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ManagementFocus } from './management-focus';

/**
 * 
 * @export
 * @interface PersonProfileDTO
 */
export interface PersonProfileDTO {
    /**
     * 
     * @type {string}
     * @memberof PersonProfileDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonProfileDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonProfileDTO
     */
    'profileImagePath'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonProfileDTO
     */
    'role'?: PersonProfileDTORoleEnum;
    /**
     * 
     * @type {ManagementFocus}
     * @memberof PersonProfileDTO
     */
    'managementFocus'?: ManagementFocus;
    /**
     * 
     * @type {Set<string>}
     * @memberof PersonProfileDTO
     */
    'capabilities'?: Set<PersonProfileDTOCapabilitiesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof PersonProfileDTO
     */
    'managedHierarchyIds'?: Set<string>;
}

export const PersonProfileDTORoleEnum = {
    Advisor: 'ADVISOR',
    Admin: 'ADMIN',
    Responsible: 'RESPONSIBLE',
    Public: 'PUBLIC',
    Manager: 'MANAGER',
    Employee: 'EMPLOYEE'
} as const;

export type PersonProfileDTORoleEnum = typeof PersonProfileDTORoleEnum[keyof typeof PersonProfileDTORoleEnum];
export const PersonProfileDTOCapabilitiesEnum = {
    CanAnswerConversations: 'CAN_ANSWER_CONVERSATIONS'
} as const;

export type PersonProfileDTOCapabilitiesEnum = typeof PersonProfileDTOCapabilitiesEnum[keyof typeof PersonProfileDTOCapabilitiesEnum];


